<template>
    <div id="home">
        <div class="ribbon">
            <div class="text-center white--text">
                <h1 style="line-height: 140px">Dahub</h1>
            </div>
        </div>

        <transition appear
                    appear-active-class="fade-enter-active"
                    leave-active-class="fade-leave-active">
            <div style="padding-top: 400px">
                <v-container class="w-25">
                    <v-alert type="success" v-if="valid">
                        Votre boite d'envoi a bien été validée.<br/>
                        Vous pourrez l'utiliser pour envoyer des e-mails avec Dahub.
                    </v-alert>

                    <v-alert type="warning" v-else>
                        Votre boite d'envoi n'a pas pu être validée.<br/>
                        Merci de contacter le support Dahub :
                        <b><a href="mailto:support@dahub.io">support@dahub.io</a></b>
                    </v-alert>
                </v-container>
            </div>
        </transition>

    </div>
</template>

<script>
    export default {
        name: "EmailValidation",
        data() {
            return {
                valid: true
            }
        },
        created() {
           this.valid = this.$route.query.state === 'success'

        }
    }
</script>